import React from "react";
import { Layout, Avatar, Menu, Dropdown, Button } from "antd";
import {
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import styles from "./header.module.scss";
import { logoutUser } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { getThemeColor } from "../../helpers";

const { Header } = Layout;

const AppHeader = ({ profile_picture, applyTheme, theme }) => {
  const navigate = useNavigate();

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<UserOutlined />}
        onClick={() => navigate("/home/profile")}
      >
        Profile
      </Menu.Item>
      <Menu.Item key="2" icon={<SettingOutlined />}>
        Settings
      </Menu.Item>
      <Menu.Item key="3" icon={<LogoutOutlined />}>
        <span onClick={logoutUser}>Logout</span>
      </Menu.Item>
    </Menu>
  );

  const colorMenu = (
    <Menu selectedKeys={[theme]}>
      <Menu.Item key="default" onClick={() => applyTheme("default")}>
        Default Theme
      </Menu.Item>
      <Menu.Item key="charcoal" onClick={() => applyTheme("charcoal")}>
        Charcoal Theme
      </Menu.Item>
      <Menu.Item key="emeraldGreen" onClick={() => applyTheme("emeraldGreen")}>
        Emerald Green Theme
      </Menu.Item>
    </Menu>
  );

  const getThemeName = () => {
    switch (theme) {
      case "default":
        return "Default";
      case "charcoal":
        return "Charcoal";
      case "emeraldGreen":
        return "Emerald";
      default:
        return "Default Theme";
    }
  };

  return (
    <Header className={styles.header}>
      <span>Transforming Risks into Strategic Opportunities</span>
      <div className={styles.rightCnt}>
        {/* <div>
          <Dropdown overlay={colorMenu} trigger={["click"]}>
            <div className={styles.themeCnt}>
              <Avatar
                size="small"
                className={styles.themeAvatar}
                style={{ backgroundColor: getThemeColor() }}
              />
              <span className={styles.themeTitle}>{getThemeName()}</span>
            </div>
          </Dropdown>
        </div> */}
        <Button
          type="default"
          icon={<DashboardOutlined />}
          onClick={() => { }}
          size="middle"
        >
          Dashboard
        </Button>

        <Dropdown overlay={menu} trigger={["click"]}>
          <Avatar
            size="large"
            icon={<UserOutlined />}
            className={styles.avatar}
            src={profile_picture}
          />
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;
